// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import VideoPlayer from '../VideoPlayer'
import 'video.js/dist/video-js.css'
import { getExtsAndTypes } from '../../config/utils'

type VideoHeaderProps = {
    src: string,
    thumbnail: ?string,
    isAudio: boolean,
    hlsVideoPlaylistUrl: ?string
}

const VideoHeaderDiv: ReactComponentStyled<{}> = styled.div`
  text-align: center;
  width: 100%;
  height: 100%;
`
VideoHeaderDiv.displayName = 'VideoHeaderDiv'

class VideoHeader extends Component<VideoHeaderProps, {}> {
  getFileType (src) {
    const { isAudio } = this.props
    if (isAudio) return 'audio/mp4'

    const ext = src?.split('?')[0].split('.').pop()
    const mimeLookup = ext ? getExtsAndTypes().types[ext] : false
    if (!mimeLookup) return 'video/mp4'
    return mimeLookup
  }

  render () {
    const { src, thumbnail, hlsVideoPlaylistUrl } = this.props
    const fileMimeType = this.getFileType(src)
    let sources = [{ src, type: fileMimeType }]

    if (hlsVideoPlaylistUrl) {
      const hlsMimeType = this.getFileType(hlsVideoPlaylistUrl)
      // overrwrite the array instead of pushing it because if the video is a .mov created on an iphone, chrome will try to play that source when it doesn't support it
      sources = [{ src: hlsVideoPlaylistUrl, type: hlsMimeType }]
    }

    const videoJsOptions = {
      sources,
      controls: true,
      nativeControlsForTouch: true,
      poster: thumbnail,
      responsive: true,
      breakpoints: {
        tiny: 300,
        xsmall: 400,
        small: 500,
        medium: 600,
        large: 700,
        xlarge: 800,
        huge: 900
      }
    }
    return (
      <VideoHeaderDiv>
        <VideoPlayer videoJsOptions={videoJsOptions} />
      </VideoHeaderDiv>
    )
  }
}

export default VideoHeader
